import { AVATARS } from '../constants/avatars';

export const getAvatar = (user) => {
  return user?.data?.avatar || AVATARS[0];
}
